import { render, staticRenderFns } from "./commentForm.vue?vue&type=template&id=4a26aef2"
import script from "./commentForm.vue?vue&type=script&lang=js"
export * from "./commentForm.vue?vue&type=script&lang=js"
import style0 from "./commentForm.vue?vue&type=style&index=0&id=4a26aef2&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a26aef2')) {
      api.createRecord('4a26aef2', component.options)
    } else {
      api.reload('4a26aef2', component.options)
    }
    module.hot.accept("./commentForm.vue?vue&type=template&id=4a26aef2", function () {
      api.rerender('4a26aef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/feedbackStatistics/components/commentForm.vue"
export default component.exports